/** @jsxImportSource @emotion/react */
import { SerializedStyles, css } from "@emotion/react";
import { useRouter } from "next/router";
import { FunctionComponent } from "react";

import { StrapiTerminusTopic } from "@/types/strapi";

import { Colors } from "@/tokens/color";
import { Spacing } from "@/tokens/spacing";

import { Flag } from "@/ui/atoms/flag";

interface TerminusTopicChipProps {
    className?: SerializedStyles;
    topics: StrapiTerminusTopic[];
}

export const TerminusTopicChipList: FunctionComponent<
    TerminusTopicChipProps
> = ({ topics }) => {
    /**
     * Hooks
     */
    const router = useRouter();

    /**
     * Methods
     */
    const handleChipClick = (e: React.MouseEvent, topicSlug: string) => {
        e.preventDefault();
        e.stopPropagation();

        router.push(`/topic/${topicSlug}`);
    };

    /**
     * Styles
     */
    const topicChipWrapperStyles = css({
        alignItems: "start",
        display: "flex",
        flexWrap: "wrap",
        gap: Spacing["spacing-2"],
    });

    const terminusTopicChipStyles = css({
        "&:hover": {
            backgroundColor: Colors["lighten-20"],
        },
        border: "none",
        cursor: "pointer",
        display: "inline-flex",
        transition: "background-color 0.2s ease",
    });

    return (
        <div css={topicChipWrapperStyles}>
            {topics.map((topic) => (
                <Flag
                    className={terminusTopicChipStyles}
                    fontFamily="mono"
                    fontSize="TerminusTopicChip"
                    isUppercase={true}
                    key={`terminus-article-card__topic-chip--${topic.Slug}`}
                    tag="button"
                    onClick={(e) => handleChipClick(e, topic.Slug)}
                >
                    {topic.Name}
                </Flag>
            ))}
        </div>
    );
};
